/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
import styled from "@emotion/styled";
import { Box, Button, Dialog, DialogActions, DialogContent, IconButton, InputAdornment, Link, Tab, Tabs, TextField, Tooltip, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import DataTable from "../../../common/DataTable";
import { ColumnDefs, ProdColumnDefs, SubCategoryColumnDef } from "./columnDefs";
import { LoadingPage } from "../../../common/LoadingPage";
import ColumnHeader from "./columnHeader";
import ColumnPanel from "../../../common/ColumnPanel";
import { useNavigate } from "react-router-dom";
import { DeleteOutline, EditOutlined } from "@mui/icons-material";
import CreateDialog from "./ProductModule/CreateDialog";
import { showNotification } from "../../../common/Notification/ToastifyNotification";
import { apiRequest } from "../../../common/common";
import FilterPanel from "./FilterPanel";
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import { ArchitecturalCode, ConnectionType, Discontinues, DissipationType, DrainLocation, ElectricalPhase, GasLocation, GasType, getSize, getWeight, Mounting, Network, PlugType, ProductType, Responsibility, Shielding, Units, VentType, VoltageType } from "../../../common/const";
import { useSelector } from "react-redux";
import ImageModal from "./ProductModule/ImageModel";
import AddItemInProject from "./addItemInProject";
import Supplier from "./supplier";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { ThreeDAccess, TwoDAccess } from '../../../common/const';


const DividerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: theme.spacing(0, 1),
  minHeight: 50
}));

const DemoBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 10
}));

const DemoBox1 = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 10,
  marginTop: 5
}));

const DemoTabs = styled(Tabs)(({ theme }) => ({
  minWidth: 200,
  borderBottom: '2px solid #e8e8e8',
  [theme.breakpoints.down('xs')]: {
    marginLeft: '0%',
  },
  [theme.breakpoints.down('md')]: {
    minWidth: '20px',
    fontSize: 10,
  },
}));

const DemoTab = styled(Tab)(({ theme }) => ({
  minWidth: 110,
  fontSize: 18,
  textTransform: 'capitalize',
  fontFamily: 'open sans',
  fontWeight: 'bold',
  [theme.breakpoints.down('xs')]: {
    minWidth: 8,
    fontSize: 10,
  },
  '&:hover': {
    backgroundColor: '#f6f7ff',
    color: 'black',
  },
}));


export default function Catalog({
  fromTemplate,
  setSelectedProduct
}) {
  const navigate = useNavigate();
  const { roles, user } = useSelector(state => state.users);
  const isUser = roles.find((a) => a.id === user?.role_id);
  const currentPlanId = user?.organization?.Subscriptions[0]?.plan_id;
  const [catalogOpen, setCatalogOpen] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [rowsPerPage, setRowPerPage] = useState(10);
  const [selectedPage, setSelectedPage] = useState(fromTemplate || currentPlanId === 7 ? 2 : localStorage?.getItem('selectedPage') ? localStorage?.getItem('selectedPage') : 0);
  const [searchingText, setSearchText] = useState(null);
  const [dataLoading, setDataLoding] = useState(false);
  const [categoryId, setCategoryId] = useState(localStorage.getItem('categoryId') ? localStorage.getItem('categoryId') : '');
  const [subCategoryId, setSubCategoryId] = useState(localStorage?.getItem('subCategoryId') ? JSON.parse(localStorage?.getItem('subCategoryId')) : []);
  const [selectedData, setSelectedData] = useState([]);
  const [activeTab, setActiveTab] = useState(fromTemplate || currentPlanId === 7 ? 1 : 0);
  const [isChecked, setIsChecked] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [returnedData, setReturnedData] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [parentId, setParentId] = useState(null);
  const [childId, setChildId] = useState(null);
  const [productId, setProductId] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [settingData, setSettingData] = useState([]);
  const [productColumn, setProductColumn] = useState(ProdColumnDefs);
  const [open, setOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState('');
  const [editedRows, setEditedRows] = useState([]);

  const onPaginationChanged = (event) => {
    if (event.api) {
      const newPageSize = event.api.paginationGetPageSize();
      setRowPerPage(newPageSize);
    }
  };

  const onGridReady = useCallback((params) => {
    if (params?.api) {
      const { api, searchingText, filters } = params;
      if (filters) {
        localStorage.setItem('filters', JSON.stringify(filters));
      }
      const filter = localStorage.getItem('filters') ? JSON.parse(localStorage.getItem('filters')) : filters
      setGridApi(api);
      setDataLoding(true);
      const dataSource = {
        rowCount: null,
        getRows: async (params) => {
          const sortModel = params?.sortModel[0];
          const sortBy = {
            column: sortModel?.colId ?
              sortModel?.colId === 'bixpand_id' ? 'sku_no' :
                sortModel?.colId === 'cad_id' ? 'prefix' :
                  sortModel?.colId === 'Description' ? 'category_name' :
                    sortModel?.colId : '',
            order: sortModel?.sort || '',
          };
          setActivePage(Math.floor((params.startRow / rowsPerPage) + 1));
          if (Number(selectedPage) === 2 && activeTab === 0) {
            const url = [
              '/product?',
              filter?.numaricSku === 'yes' ? `numaricSku=0` : '',
              filter?.category?.length > 0 ? `category=${filter.category}` : '',
              filter?.subCategory?.length > 0 ? `subCategory=${filter.subCategory}` : '',
              filter?.features?.length > 0 ? `features=${filter.features}` : '',
              filter?.manufacturer?.length > 0 ? `manufacturer=${filter.manufacturer}` : '',
              filter?.minCost !== undefined ? `minCost=${filter.minCost}` : '',
              filter?.maxCost !== undefined ? `maxCost=${filter.maxCost}` : '',
              filter?.discontinued !== undefined ? `discontinued=${filter.discontinued}` : '',
              `pageNo=${Math.floor((params.startRow / rowsPerPage) + 1)}`,
              `pageSize=${rowsPerPage}`,
              subCategoryId ? `subCategory=${subCategoryId}` : '',
              sortBy?.column ? `sortBy=${sortBy.column}` : '',
              sortBy?.order ? `sortOrder=${sortBy.order}` : '',
              searchingText ? `searchText=${encodeURIComponent(searchingText)}` : ''
            ]
              .filter(Boolean)  // Filters out empty strings
              .join('&');
            try {
              const response = await apiRequest('get', `${url}`);
              const { data, total_count } = response.data;
              setReturnedData(data);
              let lastRow = -1;
              if (data?.length <= total_count) {
                lastRow = total_count;
              }
              setSelectedData([]);
              setIsChecked(false);
              params.successCallback(data, lastRow);
            } catch (error) {
              setDataLoding(false);
              showNotification(error?.response?.data.error || error.message, 'error');
            }
          } else if (activeTab === 0) {
            try {
              const response = await apiRequest('get', `/category/list?parentId=${categoryId}&pageNo=${Math.floor((params.startRow / rowsPerPage) + 1)}&pageSize=${rowsPerPage}&type=${Number(selectedPage) === 0 ? 'category' : 'subCategory'}&searchText=${searchingText ? searchingText : ''}&sortBy=${sortBy?.column}&sortOrder=${sortBy?.order}`);
              const { data, total_count } = response.data;
              let lastRow = -1;
              if (data?.length <= total_count) {
                lastRow = total_count;
              }
              setReturnedData(data);
              params.successCallback(data, lastRow);
            } catch (error) {
              setDataLoding(false);
              showNotification(error?.response?.data.error || error.message, 'error');
            }
          } else {
            const url = [
              '/product?',
              activeTab === 3 ? `isCustomerProduct=true` : '',
              filter?.numaricSku === 'yes' ? `numaricSku=0` : '',
              filter?.category?.length > 0 ? `category=${filter.category}` : '',
              filter?.subCategory?.length > 0 ? `subCategory=${filter.subCategory}` : '',
              filter?.features?.length > 0 ? `features=${filter.features}` : '',
              filter?.manufacturer?.length > 0 ? `manufacturer=${filter.manufacturer}` : '',
              filter?.minCost !== undefined ? `minCost=${filter.minCost}` : '',
              filter?.maxCost !== undefined ? `maxCost=${filter.maxCost}` : '',
              filter?.discontinued !== undefined ? `discontinued=${filter.discontinued}` : '',
              `pageNo=${Math.floor((params.startRow / rowsPerPage) + 1)}`,
              `pageSize=${rowsPerPage}`,
              sortBy?.column ? `sortBy=${sortBy.column}` : '',
              sortBy?.order ? `sortOrder=${sortBy.order}` : '',
              searchingText ? `searchText=${encodeURIComponent(searchingText)}` : ''
            ].filter(Boolean).join('&');
            try {
              const response = await apiRequest('get', `${url}`);
              const { data, total_count } = response.data;
              setReturnedData(data);
              let lastRow = -1;
              if (data?.length <= total_count) {
                lastRow = total_count;
              }
              setSelectedData([]);
              setIsChecked(false);
              params.successCallback(data, lastRow);
            } catch (error) {
              setDataLoding(false);
              showNotification(error?.response?.data.error || error.message, 'error');
            }
          }
          setDataLoding(false);
        },
      };
      api.setGridOption("datasource", dataSource);
      setTimeout(() => {
        const node = api.getRenderedNodes();
        if (!node?.[0]?.displayed) {
          api.showNoRowsOverlay();
        }
      }, 5000);
    }
  }, [rowsPerPage, selectedPage, categoryId, activeTab]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      localStorage.removeItem('projectData');
      localStorage.removeItem('itemData');
      if (activeTab !== 2) {
        onGridReady({
          api: gridApi,
        });
      }
    }
    return () => {
      isMounted = false;
    };
  }, [rowsPerPage, selectedPage, categoryId, activeTab]);

  useEffect(() => {
    if (productColumn?.length > 0 && gridApi) {
      const columnState = gridApi?.getColumnState()?.map(state => {
        const columnConfig = productColumn.find((c) => c.colId === state.colId || c.field === state.colId);
        if (columnConfig) {
          if (columnConfig.pinned !== state.pinned) {
            state.pinned = columnConfig.pinned ? columnConfig.pinned : null;
          }
        }

        return state;
      });
      gridApi?.applyColumnState({ state: columnState });
      gridApi?.refreshHeader();
    }
  }, [productColumn]);

  const toolPanel = useMemo(() => [
    Number(selectedPage) === 2 ? {
      id: 'custom1',
      labelDefault: 'Columns',
      iconKey: "columns",
      toolPanel: ColumnPanel,
      width: 450,
      toolPanelParams: {
        columns: productColumn?.slice(3, 93),
        setColumns: (column) => {
          setProductColumn([...productColumn.slice(0, 3), ...column]);
        },
        settingData,
        fetchData: () => {
          if (user?.user_id) {
            getData();
          }
        },
        type: "product",
        defaultVisibleColumns: ProdColumnDefs?.slice(3, 93),
        columnOrder: productColumn?.slice(3, 93)
      }
    } : '',
    (Number(selectedPage) === 2 && currentPlanId !== 7) ? {
      id: 'custom2',
      iconKey: "filter",
      labelDefault: 'Filters',
      toolPanel: FilterPanel,
      width: 400,
      toolPanelParams: {
        applyFilter: (filters) => {
          setRowPerPage(10);
          onGridReady({
            api: gridApi,
            filters
          });
        }
      }
    } : '',
  ], [selectedPage, gridApi, settingData, productColumn]);

  const onSelectChanged = (value) => {
    if (gridApi) {
      if (value === 1) {
        const selectedNodes = gridApi.getSelectedNodes();
        gridApi.forEachNode((node) => {
          selectedNodes.push(node);
          node.setSelected(true);
        });
        const uniqueNodesSet = new Set(selectedNodes);
        const uniqueNodesArray = Array.from(uniqueNodesSet);
        if (Number(selectedPage) === 1) {
          const data = uniqueNodesArray.map((node) => node.data.category_id);
          setSelectedData(data);
          setSubCategoryId(data);
        } else {
          const data = uniqueNodesArray.map((node) => node.data);
          setSelectedData(data);
        }
      } else if (value === 2) {
        const selectedNodes = gridApi.getSelectedNodes();
        selectedNodes.forEach((node) => node.setSelected(false));
      }
    }
  };

  const removeAllColumn = () => {
    if (gridApi) {
      setSelectedData([]);
      setSubCategoryId([]);
      setIsChecked(false);
      setIndeterminate(false);
      const selectedNodes = gridApi.getSelectedNodes();
      selectedNodes.forEach((node) => node.setSelected(false));
    }
  };

  const updatedColumns = useMemo(() => {
    let column = [];
    if (Number(selectedPage) === 0) {
      column = ColumnDefs;
      if (column.length > 0) {
        return column.map((col) => {
          if (col.field === 'name') {
            return {
              ...col,
              cellRenderer: (params) => (
                <Link
                  style={{ textDecoration: 'none', cursor: 'pointer' }}
                  onClick={() => {
                    setCategoryId(params?.data?.category_id);
                    setParentId(params?.data?.category_id);
                    localStorage.setItem('categoryId', params?.data?.category_id);
                    setSelectedPage(1);
                  }}
                >
                  {params?.data?.name}
                </Link>
              ),
            };
          }
          if (col.field === 'prefix') {
            return {
              ...col,
              hide: !['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code),
              cellRenderer: (params) => (
                <span>
                  {params?.data?.prefix}
                </span>
              ),
            }
          }
          if (col.field === 'sku_no') {
            return {
              ...col,
              hide: !['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code),
              cellRenderer: (params) => (
                <span>
                  {params?.data?.sku_no}
                </span>
              ),
            }
          }
          if (col.field === '_count') {
            return {
              ...col,
              cellRenderer: (params) => (
                <Link
                  style={{ textDecoration: 'none', cursor: 'pointer' }}
                  onClick={() => {
                    setCategoryId(params?.data?.category_id);
                    setParentId(params?.data?.category_id);
                    localStorage.setItem('categoryId', params?.data?.category_id);
                    setSelectedPage(1);
                  }}
                >
                  {params?.data?.["_count"]?.sub_categories}
                </Link>
              ),
            };
          }
          if (col.field === 'action') {
            return {
              ...col,
              hide: !['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code),
              cellRenderer: (params) => (
                <>
                  <Tooltip title="Edit Category">
                    <EditOutlined
                      color="primary"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setDialogOpen(true);
                        setParentId(params?.data?.category_id);
                      }}
                    />
                  </Tooltip>
                  <Tooltip title="Delete Category">
                    <DeleteOutline
                      color="secondary"
                      style={{ cursor: 'pointer', marginLeft: 5 }}
                      onClick={() => {
                        setDeleteOpen(true);
                        setParentId(params?.data?.category_id);
                      }}
                    />
                  </Tooltip>
                </>
              ),
            };
          }
          return col;
        })
      }
    } else if (Number(selectedPage) === 1) {
      column = SubCategoryColumnDef;
      if (column.length > 0) {
        return column.map((col) => {
          if (col?.field === '') {
            return {
              ...col,
              headerComponent: ColumnHeader,
              headerComponentParams: {
                onSelectChanged,
                removeAllColumn,
                isChecked,
                setIsChecked,
                indeterminate,
                setIndeterminate,
              },
            };
          }
          if (col.field === 'action') {
            return {
              ...col,
              hide: !['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code),
              cellRenderer: (params) => (
                <>
                  <Tooltip title="Edit SubCategory">
                    <EditOutlined
                      color="primary"
                      style={{ cursor: 'pointer', color: selectedData.includes(params?.data?.category_id) ? '' : 'gray' }}
                      onClick={() => {
                        if (selectedData.includes(params?.data?.category_id)) {
                          setDialogOpen(true);
                          setChildId(params?.data?.category_id);
                        }
                      }}
                    />
                  </Tooltip>
                  <Tooltip title="Delete SubCategory">
                    <DeleteOutline
                      color="secondary"
                      style={{ cursor: 'pointer', marginLeft: 5, color: selectedData.includes(params?.data?.category_id) ? '' : 'gray' }}
                      onClick={() => {
                        if (selectedData.includes(params?.data?.category_id)) {
                          setDeleteOpen(true);
                          setChildId(params?.data?.category_id);
                        }
                      }}
                    />
                  </Tooltip>
                </>
              ),
            };
          }
          if (col.field === 'prefix') {
            return {
              ...col,
              hide: !['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code),
              cellRenderer: (params) => (
                <span>
                  {params?.data?.prefix}
                </span>
              ),
            }
          }
          if (col.field === 'sku_no') {
            return {
              ...col,
              hide: !['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code),
              cellRenderer: (params) => (
                <span>
                  {params?.data?.sku_no}
                </span>
              ),
            }
          }
          return col;
        });
      }
    } else {
      column = productColumn;
      if (column.length > 0) {
        return column.map((col) => {
          switch (col.field) {
            case '':
              if (!fromTemplate) {
                return {
                  ...col,
                  headerComponent: ColumnHeader,
                  headerComponentParams: {
                    onSelectChanged,
                    removeAllColumn,
                    isChecked,
                    setIsChecked,
                    indeterminate,
                    setIndeterminate,
                  },
                };
              }
              return {
                ...col
              }
            case 'action':
              return {
                ...col,
                flex: 1,
                minWidth: 90,
                hide: fromTemplate || !['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code),
                cellRenderer: (params) => (
                  <>
                    <Tooltip title="Edit Product">
                      <EditOutlined
                        color="primary"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          navigate(`/app/catalog/create-product?id=${params?.data.product_id}`)
                        }}
                      />
                    </Tooltip>
                    <Tooltip title='Delete Product'>
                      <DeleteOutline
                        color="secondary"
                        style={{ cursor: 'pointer', marginLeft: 5 }}
                        onClick={() => {
                          setDeleteOpen(true);
                          setProductId(params?.data?.product_id);
                        }}
                      />
                    </Tooltip>
                  </>
                ),
              };
            case 'model':
              return {
                ...col,
                flex: 1,
                minWidth: 200,
                cellRenderer: (params) => {
                  if (params?.data?.model !== 'null') {
                    return (
                      <Link
                        style={{ textDecoration: 'none', cursor: 'pointer' }}
                        onClick={() => window.open(`/app/catalog/product/ct/${params?.data.product_id}`, '_blank')}
                      >
                        {params?.data?.model ? params?.data?.model : '--'}
                      </Link>
                    )
                  }
                  return '';
                },
              };
            case 'created_by': {
              return {
                ...col,
                hide: !['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) || activeTab === 1,
                cellRenderer: (params) => {
                  if (params?.data?.user !== 'null') {
                    return (
                      params?.data?.user ? `${params?.data?.user?.first_name} ${params?.data?.user?.last_name !== 'null' ? params?.data?.user?.last_name : ''}` : ''
                    )
                  }
                  return '';
                },
              };
            }
            case 'catalog':
              return {
                ...col,
                flex: 1,
                minWidth: 150,
                cellRenderer: (params) => {
                  if (params?.data?.catalog !== 'null') {
                    return (
                      params?.data?.catalog ? params?.data?.catalog : ''
                    )
                  }
                  return '';
                },
              };
            case 'bixpand_id':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  return (
                    <Link
                      style={{ textDecoration: 'none', cursor: 'pointer' }}
                      onClick={() => window.open(`/app/catalog/product/ct/${params?.data.product_id}`, '_blank')}
                    >
                      {params?.data?.is_customer_product ? `C-${params?.data?.alternate_id}` :
                        params?.data?.category?.["sku_no"] ? `${params?.data?.category?.["sku_no"]}${params?.data?.sub_category?.["sku_no"]}-${String(params?.data?.["numaric_sku"]).padStart(3, '0')}` : '--'
                      }
                    </Link>
                  );
                },
              };
            case 'cad_id':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  return (
                    <Link
                      style={{ textDecoration: 'none', cursor: 'pointer' }}
                      onClick={() => window.open(`/app/catalog/product/ct/${params?.data.product_id}`, '_blank')}
                    >
                      {params?.data?.is_customer_product ? `C-${params?.data?.alternate_id}` : params?.data?.category?.prefix ? `${params?.data?.category?.prefix}${params?.data?.sub_category?.prefix}-${String(params?.data?.["numaric_sku"]).padStart(3, '0')}` : '--'}
                    </Link>
                  );
                },
              };
            case 'images':
              return {
                ...col,
                flex: 1,
                minWidth: 75,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <Box sx={{ height: '100%', width: '30px', display: 'flex', justifyContent: 'center' }}>
                        <img
                          src={params?.data?.images?.[0]?.sortUrl ? `${process.env.REACT_APP_IMAGEURL}bbn=${params?.data?.images?.[0]?.sortUrl}&uid=${user?.user_id}` : 'https://dummyimage.com/100x100/000/fff'}
                          style={{ height: '100%', cursor: 'pointer' }}
                          onClick={() => {
                            setOpen(true);
                            setImageSrc(params?.data?.images?.[0]?.sortUrl ? `${process.env.REACT_APP_IMAGEURL}bbn=${params?.data?.images?.[0]?.sortUrl}&uid=${user?.user_id}` : 'https://dummyimage.com/100x100/000/fff');
                          }}
                        />
                      </Box>
                    );
                  }
                  return '';
                },
              };
            case 'category':
              return {
                ...col,
                flex: 1,
                minWidth: 175,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.category?.name}</span>
                    );
                  }
                  return '';
                },
              };
            case 'sub_category':
              return {
                ...col,
                flex: 1,
                minWidth: 200,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.["sub_category"]?.name}</span>
                    );
                  }
                  return '';
                },
              };
            case 'Description':
              return {
                ...col,
                flex: 1,
                minWidth: 275,
                cellRenderer: (params) => {
                  return (
                    <span>{`${params?.data?.category?.name ? params?.data?.category?.name : ''}, ${params?.data?.["sub_category"]?.name ? params?.data?.["sub_category"]?.name : ''}`}</span>
                  );
                },
              };
            case 'manufacturer':
              return {
                ...col,
                flex: 1,
                minWidth: 200,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.manufacturer?.name ? params?.data?.manufacturer?.name : ''}</span>
                  );
                },
              };
            case 'vendor':
              return {
                ...col,
                flex: 1,
                minWidth: 200,
                sortable: false,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.vendor?.name ? params?.data?.vendor?.name : ''}</span>
                  );
                },
              };
            case 'description':
              return {
                ...col,
                flex: 1,
                minWidth: 220,
                sortable: false,
                editable: ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code),
                cellStyle: () => ({
                  backgroundColor: ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) ? 'lightgray' : 'white',
                  border: ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && 'none',
                }),
                cellRenderer: (params) => {
                  return (
                    <Tooltip title={params?.data?.description ? params?.data?.description : ''}>
                      <span>{params?.data?.description ? params?.data?.description.slice(0, 50) : '--'}</span>
                    </Tooltip>
                  );
                },
              };
            case 'list_price':
              return {
                ...col,
                flex: 1,
                minWidth: 125,
                editable: ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code),
                cellStyle: () => ({
                  backgroundColor: ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) ? 'lightgray' : 'white',
                  border: ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && 'none',
                }),
                cellRenderer: (params) => {
                  if (params?.data?.list_price) {
                    return (
                      <span>{`₹ ${params?.data?.list_price !== null ? Intl.NumberFormat('en-IN').format(params?.data?.list_price) : 0}`}</span>
                    );
                  }
                  return 0;
                },
              };
            case 'notes':
              return {
                ...col,
                flex: 1,
                minWidth: 220,
                sortable: false,
                editable: ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code),
                cellStyle: () => ({
                  backgroundColor: ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) ? 'lightgray' : 'white',
                  border: ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && 'none',
                }),
                cellRenderer: (params) => {
                  return (
                    <Tooltip title={params?.data?.notes ? params?.data?.notes : ''}>
                      <span>{params?.data?.notes ? params?.data?.notes.slice(0, 50) : '--'}</span>
                    </Tooltip>
                  );
                },
              };
            case 'discontinued':
              return {
                ...col,
                sortable: false,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  return (
                    <span>{Discontinues.find((a) => a.value === params?.data?.discontinued)?.name || '--'}</span>
                  );
                },
              };
            case 'type':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  return (
                    <span>{ProductType.find((a) => a.value === params?.data?.type)?.name || '--'}</span>
                  );
                },
              };
            case 'furnish_responsibility':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  return (
                    <span>{Responsibility.find((a) => a.value === params?.data?.furnish_responsibility)?.name || '--'}</span>
                  );
                },
              };
            case 'install_responsibility':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  return (
                    <span>{Responsibility.find((a) => a.value === params?.data?.install_responsibility)?.name || '--'}</span>
                  );
                },
              };
            case 'architectural_code':
              return {
                ...col,
                flex: 1,
                minWidth: 110,
                sortable: false,
                cellRenderer: (params) => {
                  return (
                    <span>{ArchitecturalCode.find((a) => a.value === params?.data?.architectural_code)?.name || '--'}</span>
                  );
                },
              };
            case 'custom_id_1':
              return {
                ...col,
                flex: 1,
                minWidth: 110,
                sortable: false,
                editable: (params) => params.value !== 'locked',
                cellStyle: () => ({
                  backgroundColor: 'lightgray',
                  border: 'none',
                }),
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.custom_id_1 !== null ? params?.data?.custom_id_1 : '--'}</span>
                  );
                },
              };
            case 'custom_id_2':
              return {
                ...col,
                flex: 1,
                minWidth: 110,
                sortable: false,
                editable: (params) => params.value !== 'locked',
                cellStyle: () => ({
                  backgroundColor: 'lightgray',
                  border: 'none',
                }),
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.custom_id_2 !== null ? params?.data?.custom_id_2 : '--'}</span>
                  );
                },
              };
            case 'govt_id':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                sortable: false,
                editable: (params) => params.value !== 'locked',
                cellStyle: () => ({
                  backgroundColor: 'lightgray',
                  border: 'none',
                }),
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.govt_id !== null ? params?.data?.govt_id : '--'}</span>
                  );
                },
              };
            case 'alternate_id':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.alternate_id !== null ? `C-${params?.data?.alternate_id}` : '--'}</span>
                  );
                },
              };
            case 'inventory_id':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.alternate_id !== null ? params?.data?.inventory_id : '--'}</span>
                  );
                },
              };
            case 'architecturally_significant':
              return {
                ...col,
                sortable: false,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.architecturally_significant !== null ? (params?.data?.architecturally_significant ? 'Yes' : 'No') : '--'}</span>
                  );
                },
              };
            case 'spatially_significant':
              return {
                ...col,
                sortable: false,
                flex: 1,
                minWidth: 100,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.spatially_significant !== null ? (params?.data?.spatially_significant ? 'Yes' : 'No') : '--'}</span>
                  );
                },
              };
            case 'units':
              return {
                ...col,
                sortable: false,
                flex: 1,
                minWidth: 80,
                cellRenderer: (params) => {
                  return (
                    <span>{Units.find((a) => a.value === params?.data?.units)?.name}</span>
                  );
                },
              };
            case 'width':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return getSize(params?.data?.units, params?.data?.width);
                  }
                  return '';
                },
              };
            case 'height':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return getSize(params?.data?.units, params?.data?.height);
                  }
                  return '';
                },
              };
            case 'depth':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return getSize(params?.data?.units, params?.data?.depth);
                  }
                  return '';
                },
              };
            case 'clearance':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return getSize(params?.data?.units, params?.data?.clearance?.left);
                  }
                  return '';
                },
              };
            case 'clearance_right':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return getSize(params?.data?.units, params?.data?.clearance?.right);
                  }
                  return '';
                },
              };
            case 'clearance_back':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return getSize(params?.data?.units, params?.data?.clearance?.back);
                  }
                  return '';
                },
              };
            case 'clearance_front':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return getSize(params?.data?.units, params?.data?.clearance?.front);
                  }
                  return '';
                },
              };
            case 'clearance_top':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return getSize(params?.data?.units, params?.data?.clearance?.top);
                  }
                  return '';
                },
              };
            case 'clearance_bottom':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return getSize(params?.data?.units, params?.data?.clearance?.bottom);
                  }
                  return '';
                },
              };
            case 'mouting':
              return {
                ...col,
                flex: 1,
                minWidth: 140,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return <span>{Mounting.find((a) => a.value === params?.data?.mounting)?.name}</span>
                  }
                  return '';
                },
              };
            case 'max_weight':
              return {
                ...col,
                flex: 1,
                minWidth: 140,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return getWeight(params?.data?.units, params?.data?.max_weight);
                  }
                  return '';
                },
              };
            case 'ship_weight':
              return {
                ...col,
                flex: 1,
                minWidth: 140,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return getWeight(params?.data?.units, params?.data?.ship_weight);
                  }
                  return '';
                },
              };
            case 'operating_weight':
              return {
                ...col,
                flex: 1,
                minWidth: 140,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return getWeight(params?.data?.units, params?.data?.operating_weight);
                  }
                  return '';
                },
              };
            case 'da_complient':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                sortable: false,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.da_complient !== null ? (params?.data?.da_complient ? 'Yes' : 'No') : '--'}</span>
                  );
                },
              };
            case 'antimicrobial':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.antimicrobial !== null ? (params?.data?.antimicrobial ? 'Yes' : 'No') : '--'}</span>
                  );
                },
              };
            case 'green':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                sortable: false,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.green !== null ? (params?.data?.green ? 'Yes' : 'No') : '--'}</span>
                  );
                },
              };
            case 'Shielding':
              return {
                ...col,
                flex: 1,
                minWidth: 90,
                sortable: false,
                cellRenderer: (params) => {
                  return (
                    <span>{Shielding?.find((a) => a.value === params?.data?.Shielding)?.name || '--'}</span>
                  );
                },
              };
            case 'seismic':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                sortable: false,
                cellRenderer: (params) => {
                  return (
                    <span>{params?.data?.seismic !== null ? (params?.data?.seismic ? 'Yes' : 'No') : '--'}</span>
                  );
                },
              };
            case 'spatial_remarks':
              return {
                ...col,
                flex: 1,
                minWidth: 220,
                sortable: false,
                cellRenderer: (params) => {
                  return (
                    <Tooltip title={params?.data?.spatial_remarks ? params?.data?.spatial_remarks : ''}>
                      <span>{params?.data?.spatial_remarks ? params?.data?.spatial_remarks.slice(0, 50) : '--'}</span>
                    </Tooltip>
                  );
                },
              };
            case 'electrical_data':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{VoltageType.find((a) => a.value === params?.data?.electrical_data?.voltageType)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'volts':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.electrical_data?.volts ? `${params?.data?.electrical_data?.volts} V` : '--'} </span>
                    );
                  }
                  return '';
                },
              };
            case 'amps':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.electrical_data?.amps ? `${params?.data?.electrical_data?.amps} A` : '--'} </span>
                    );
                  }
                  return '';
                },
              };
            case 'watts':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.electrical_data?.watts ? `${params?.data?.electrical_data?.watts} W` : '--'} </span>
                    );
                  }
                  return '';
                },
              };
            case 'kva':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.electrical_data?.kva ? `${params?.data?.electrical_data?.kva} kVA` : '--'} </span>
                    );
                  }
                  return '';
                },
              };
            case 'hertz':
              return {
                ...col,
                flex: 1,
                minWidth: 70,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.electrical_data?.hertz ? `${params?.data?.electrical_data?.hertz} Hz` : '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'electric_phase':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{ElectricalPhase.find((a) => a.value === params?.data?.electrical_data?.electricalPhase)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'plug_type':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{PlugType.find((a) => a.value === params?.data?.electrical_data?.plugtype)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'plug_details':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.electrical_data?.plugdetail || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'emergency_power':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.electrical_data?.emergencyPower ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'remote_transformer':
              return {
                ...col,
                flex: 1,
                minWidth: 105,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.electrical_data?.remoteTrans ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'remote_switch':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.electrical_data?.remoteSwitch ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'electrical_remark':
              return {
                ...col,
                flex: 1,
                minWidth: 220,
                sortable: false,
                cellRenderer: (params) => {
                  return (
                    <Tooltip title={params?.data?.electrical_data?.electricalRemarks ? params?.data?.electrical_data?.electricalRemarks : ''}>
                      <span>{params?.data?.electrical_data?.electricalRemarks ? params?.data?.electrical_data?.electricalRemarks.slice(0, 50) : '--'}</span>
                    </Tooltip>
                  );
                },
              };
            case 'tech_connection_data':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.tech_connection_data?.isConnection ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'connection_type':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{ConnectionType.find((a) => a.value === params?.data?.tech_connection_data?.connectionType)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'network':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{Network.find((a) => a.value === params?.data?.tech_connection_data?.network)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'technical_remarks':
              return {
                ...col,
                flex: 1,
                minWidth: 220,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data?.tech_connection_data?.isConnection) {
                    return (
                      <Tooltip title={params?.data?.tech_connection_data?.techRemarks ? params?.data?.tech_connection_data?.techRemarks : ''}>
                        <span>{params?.data?.tech_connection_data?.techRemarks ? params?.data?.tech_connection_data?.techRemarks.slice(0, 50) : '--'}</span>
                      </Tooltip>
                    )
                  }
                  return '--'
                },
              };
            case 'plumbing_data':
              return {
                ...col,
                flex: 1,
                minWidth: 70,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.plumbing_data?.coldWater ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'hot':
              return {
                ...col,
                flex: 1,
                minWidth: 70,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.plumbing_data?.hotWater ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'treated':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.plumbing_data?.treatedWater ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'steam':
              return {
                ...col,
                flex: 1,
                minWidth: 70,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.plumbing_data?.steam ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'medical_vaccum':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.plumbing_data?.vaccumMedical ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'dental_vaccum':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.plumbing_data?.vaccumDental ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'medical_gas':
              return {
                ...col,
                flex: 1,
                minWidth: 80,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.plumbing_data?.medicalgas ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'drain':
              return {
                ...col,
                flex: 1,
                minWidth: 70,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.plumbing_data?.drain ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'drain_location':
              return {
                ...col,
                flex: 1,
                minWidth: 90,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{DrainLocation.find((a) => a.value === params?.data?.plumbing_data?.drainLocation)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'gas_type':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{GasType.find((a) => a.value === params?.data?.plumbing_data?.gasType)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'gas_location':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{GasLocation.find((a) => a.value === params?.data?.plumbing_data?.gasLocation)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'plumbing_remarks':
              return {
                ...col,
                flex: 1,
                minWidth: 220,
                sortable: false,
                cellRenderer: (params) => {
                  return (
                    <Tooltip title={params?.data?.plumbing_data?.plumbingRemarks ? params?.data?.plumbing_data?.plumbingRemarks : ''}>
                      <span>{params?.data?.plumbing_data?.plumbingRemarks ? params?.data?.plumbing_data?.plumbingRemarks.slice(0, 50) : '--'}</span>
                    </Tooltip>
                  );
                },
              };
            case 'mechanical_data':
              return {
                ...col,
                flex: 1,
                minWidth: 70,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.mechanical_data?.vent ? 'Yes' : 'No'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'vent_type':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.mechanical_data?.vent ? (VentType.find((a) => a.value === params?.data?.mechanical_data?.ventType)?.name || '--') : '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'heat_hr':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{params?.data?.mechanical_data?.heatDissipation || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'dissipation_type':
              return {
                ...col,
                flex: 1,
                minWidth: 100,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    return (
                      <span>{DissipationType.find((a) => a.value === params?.data?.mechanical_data?.dissipationType)?.name || '--'}</span>
                    );
                  }
                  return '';
                },
              };
            case 'mechanical_remarks':
              return {
                ...col,
                flex: 1,
                minWidth: 220,
                sortable: false,
                cellRenderer: (params) => {
                  return (
                    <Tooltip title={params?.data?.mechanical_data?.mechanicalRemarks ? params?.data?.mechanical_data?.mechanicalRemarks : ''}>
                      <span>{params?.data?.mechanical_data?.mechanicalRemarks ? params?.data?.mechanical_data?.mechanicalRemarks.slice(0, 50) : '--'}</span>
                    </Tooltip>
                  );
                },
              };
            case 'specifications_doc':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    if (params?.data?.["specifications_doc"]?.[0]?.sortUrl) {
                      return (
                        <a href={`${process.env.REACT_APP_IMAGEURL}bbn=${params?.data?.["specifications_doc"]?.[0]?.sortUrl}&uid=${user?.user_id}`} target="_blank" rel="noreferrer">
                          <img src="/images/pdf.svg" alt="blog img" style={{ width: 16, margin: '3px 10px 10px 40px' }} />
                        </a>
                      );
                    }
                    return '--';
                  }
                  return '';
                },
              };
            case 'brochure_doc':
              return {
                ...col,
                sortable: false,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  if (params?.data) {
                    if (params?.data?.["brochure_doc"]?.[0]?.sortUrl) {
                      return (
                        <a href={`${process.env.REACT_APP_IMAGEURL}bbn=${params?.data?.["brochure_doc"]?.[0]?.sortUrl}}&uid=${user?.user_id}`} target="_blank" rel="noreferrer">
                          <img src="/images/pdf.svg" alt="blog img" style={{ width: 16, margin: '3px 10px 10px 40px' }} />
                        </a>
                      );
                    }
                    return '--';
                  }
                  return '';
                },
              };
            case 'site_planning_doc':
              return {
                ...col,
                sortable: false,
                flex: 1,
                minWidth: 120,
                cellRenderer: (params) => {
                  if (params?.data) {
                    if (params?.data?.["site_planning_doc"]?.[0]?.sortUrl) {
                      return (
                        <a href={`${process.env.REACT_APP_IMAGEURL}${params?.data?.["site_planning_doc"]?.[0]?.sortUrl}`} target="_blank" rel="noreferrer">
                          <img src="/images/pdf.svg" alt="blog img" style={{ width: 16, margin: '3px 10px 10px 40px' }} />
                        </a>
                      );
                    }
                    return '--';
                  }
                  return '';
                },
              };
            case 'operating_manual_doc':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    if (params?.data?.["operating_manual_doc"]?.[0]?.sortUrl) {
                      return (
                        <a href={`${process.env.REACT_APP_IMAGEURL}bbn=${params?.data?.["operating_manual_doc"]?.[0]?.sortUrl}}&uid=${user?.user_id}`} target="_blank" rel="noreferrer">
                          <img src="/images/pdf.svg" alt="blog img" style={{ width: 16, margin: '3px 10px 10px 40px' }} />
                        </a>
                      );
                    }
                    return '--';
                  }
                  return '';
                },
              };
            case 'website_url':
              return {
                ...col,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    if (params?.data?.["website_url"]?.length > 0) {
                      return (params?.data?.["website_url"]?.map((a, index) => (
                        <React.Fragment key={index}>
                          <Tooltip title={a}>
                            <a href={a} target="_blank" rel="noreferrer">
                              {a.slice(0, 50)}
                            </a>
                          </Tooltip>
                          {index < params.data["website_url"].length - 1 && ", "}
                        </React.Fragment>
                      )));
                    }
                    return '--';
                  }
                  return '';
                },
              };
            case 'twod_doc':
              return {
                ...col,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    if (params?.data?.["twod_doc"]?.[0]?.sortUrl) {
                      if (TwoDAccess.includes(currentPlanId) || ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code)) {
                        return (
                          <a href={`${process.env.REACT_APP_IMAGEURL}bbn=${params?.data?.["twod_doc"]?.[0]?.sortUrl}}&uid=${user?.user_id}`} target="_blank" rel="noreferrer">
                            <img src="/images/autocad.png" alt="blog img" style={{ width: 19, margin: '3px 10px 10px 0px' }} />
                          </a>
                        );
                      } else {
                        return '--';
                      }
                    }
                    return '--';
                  }
                  return '';
                },
              };
            case 'threed_doc':
              return {
                ...col,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    if (params?.data?.["threed_doc"]?.[0]?.sortUrl) {
                      if (ThreeDAccess === currentPlanId || ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code)) {
                        return (
                          <a href={`${process.env.REACT_APP_IMAGEURL}bbn=${params?.data?.["threed_doc"]?.[0]?.sortUrl}}&uid=${user?.user_id}`} target="_blank" rel="noreferrer">
                            <img src="/images/ravit.jpeg" alt="blog img" style={{ width: 19, margin: '3px 10px 10px 0px' }} />
                          </a>
                        );
                      } else {
                        return '--';
                      }
                    }
                    return '--';
                  }
                  return '';
                },
              };
            case 'documents':
              return {
                ...col,
                flex: 1,
                minWidth: 120,
                sortable: false,
                cellRenderer: (params) => {
                  if (params?.data) {
                    if (params?.data?.["documents"]?.[0]?.sortUrl) {
                      return (
                        <a href={`${process.env.REACT_APP_IMAGEURL}bbn=${params?.data?.["documents"]?.[0]?.sortUrl}}&uid=${user?.user_id}`} target="_blank" rel="noreferrer">
                          <img src="/images/pdf.svg" alt="blog img" style={{ width: 16, margin: '3px 10px 10px 0px' }} />
                        </a>
                      );
                    }
                    return '--';
                  }
                  return '';
                },
              };
            default:
              return col;
          }
        });
      }
    }
    return column;
  }, [selectedPage, isChecked, indeterminate, productColumn, selectedData, fromTemplate]);

  const getData = async () => {
    try {
      const response = await apiRequest('get', `/user-view?userId=${user?.user_id}&type=product&pageNo=1&pageSize=50`);
      const { data } = response.data;
      if (data?.length > 0) {
        if (data?.find((a) => a.is_pinned === true)?.columns) {
          setProductColumn([...productColumn.slice(0, 3), ...data?.find((a) => a.is_pinned === true)?.columns]);
        }
        setSettingData(data);
      } else {
        setSettingData([]);
      }
    } catch (error) {
      setDataLoding(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  useEffect(() => {
    if (user?.user_id) {
      getData();
    }
  }, [user?.user_id]);

  return (
    <Box component="main" sx={{ flexGrow: 1, p: fromTemplate ? '0px 10px' : 3 }}>
      {dataLoading && <LoadingPage isLoading={dataLoading} />}
      {!fromTemplate && (<DividerHeader />)}
      <Dialog open={deleteOpen} fullWidth maxWidth="xs">
        <DialogContent>Are you sure to delete this one?</DialogContent>
        <DialogActions>
          <Button size="small" variant="contained" color="secondary"
            onClick={() => {
              setChildId(null);
              setParentId(null);
              setProductId(null);
              setDeleteOpen(false);
            }}
          >
            No
          </Button>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={async () => {
              try {
                setDataLoding(true);
                let response = '';
                if (productId) {
                  response = await apiRequest('delete', `/product/${productId}`);
                } else {
                  response = await apiRequest('delete', `/category/${childId ? childId : parentId}`);
                }
                if (response?.data) {
                  setDataLoding(false);
                  showNotification(response?.data?.message, 'success');
                  setChildId(null);
                  setParentId(null);
                  setProductId(null);
                  setDeleteOpen(false);
                  onGridReady({
                    api: gridApi
                  });
                }
              } catch (error) {
                setDataLoding(false);
                showNotification(error?.response?.data.error || error.message, 'error');
              }
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <CreateDialog
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        selectedPage={selectedPage}
        categoryId={parentId}
        subCategoryId={childId}
        onGridReady={() => {
          setParentId(null);
          setChildId(null);
          onGridReady({
            api: gridApi,
          });
        }}
      />
      <ImageModal
        imageSrc={imageSrc}
        open={open}
        onClose={() => {
          setOpen(false);
          setImageSrc('');
        }}
      />
      {!fromTemplate && (
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <DemoTabs
            value={activeTab}
            variant="scrollable"
            scrollButtons="auto"
          >
            {currentPlanId !== 7 && (<DemoTab
              label="Category"
              value={0}
              onClick={() => {
                setSelectedPage(0);
                setRowPerPage(10);
                setActiveTab(0);
                setCategoryId('');
                setIsChecked(false);
                setSelectedData([]);
                setSearchText('');
                localStorage.removeItem('subCategoryId');
                localStorage.removeItem('selectedPage');
                localStorage.removeItem('categoryId');
              }} />)}
            <DemoTab
              label="Products"
              value={1}
              onClick={() => {
                setSelectedPage(2);
                setRowPerPage(50);
                setActiveTab(1);
                setCategoryId('');
                setIsChecked(false);
                setSelectedData([]);
                setSearchText('');
                localStorage.removeItem('subCategoryId');
                localStorage.removeItem('selectedPage');
                localStorage.removeItem('categoryId');
              }} />
            {currentPlanId !== 7 && (
              <DemoTab
                label="Supplier"
                value={2}
                onClick={() => {
                  setRowPerPage(10);
                  setActiveTab(2);
                  setCategoryId('');
                  setIsChecked(false);
                  setSelectedData([]);
                  setSearchText('');
                  localStorage.removeItem('subCategoryId');
                  localStorage.removeItem('selectedPage');
                  localStorage.removeItem('categoryId');
                }} />
            )}
            {['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && (
              <DemoTab
                label="Custom Product"
                value={3}
                onClick={() => {
                  setSelectedPage(2);
                  setRowPerPage(50);
                  setActiveTab(3);
                  setCategoryId('');
                  setIsChecked(false);
                  setSelectedData([]);
                  setSearchText('');
                  localStorage.removeItem('subCategoryId');
                  localStorage.removeItem('selectedPage');
                  localStorage.removeItem('categoryId');
                }} />
            )}
          </DemoTabs>
        </Box>
      )}
      <DemoBox1>
        {activeTab !== 2 && selectedData?.length > 0 && !fromTemplate ? (
          <>
            <Typography>Selected Item: {selectedData?.length}</Typography>
            {Number(selectedPage) === 1 ? (
              <Button
                variant="outlined"
                size="Medium"
                color="primary"
                onClick={() => {
                  setSelectedPage(2);
                  setCategoryId('');
                  localStorage.setItem('subCategoryId', JSON.stringify(subCategoryId));
                  localStorage.setItem('selectedPage', 2);
                }}
              >
                Get Product
              </Button>
            ) : (
              <>
                {catalogOpen && (
                  <AddItemInProject
                    catalogOpen={catalogOpen}
                    setCatalogOpen={setCatalogOpen}
                    selectedData={selectedData}
                    setSelectedData={() => {
                      setSelectedData([]);
                      onGridReady({
                        api: gridApi
                      })
                    }}
                  />
                )}
                <Button
                  size="Medium"
                  variant="outlined"
                  startIcon={<CreateNewFolderOutlinedIcon color="primary" />}
                  onClick={() => {
                    setCatalogOpen(true);
                  }}
                >
                  Add To Project
                </Button>
              </>
            )}
          </>
        ) : (
          <>
            {!fromTemplate ? (activeTab === 0 ? (
              <Typography variant='h4' style={{ fontWeight: 'bold' }}>
                <Link
                  style={{ textDecoration: 'none', cursor: 'pointer' }}
                  onClick={() => {
                    setSelectedPage(0);
                    setCategoryId('');
                    localStorage.removeItem('selectedPage');
                    localStorage.removeItem('subCategoryId');
                    localStorage.removeItem('categoryId');
                  }}>
                  Categories
                </Link>
                {(Number(selectedPage) === 1 || Number(selectedPage) === 2) && (
                  <Link style={{ textDecoration: 'none', cursor: 'pointer' }}
                    onClick={() => {
                      setSelectedPage(1);
                      localStorage.removeItem('selectedPage');
                      localStorage.removeItem('subCategoryId');
                    }}
                  >
                    /Subcategories
                  </Link>)}
                {(Number(selectedPage) === 2) && (
                  <Link
                    style={{ textDecoration: 'none', cursor: 'pointer' }}
                    onClick={() => {
                      setSelectedPage(2);
                    }}>
                    /Products
                  </Link>)}
              </Typography>
            ) : activeTab !== 2 && (
              <Typography variant='h4' style={{ fontWeight: 'bold' }}>
                Products
              </Typography>
            )) : ''}
            {activeTab !== 2 && (
              <DemoBox>
                {Number(selectedPage) !== 2 ? (
                  <>
                    {isUser?.code === 'mvedasMasterAdmin' || isUser?.code === 'mvedasAdmin' ? (
                      <Tooltip title="Download Category / SubCategory List">
                        <IconButton
                          onClick={async () => {
                            const response = await apiRequest('get', `/category/subcategory-list`);
                            const { data } = response.data;
                            const updatedData = data.map((d) => {
                              return {
                                subCategory: d.name,
                                category: d.parent?.name,
                                product_count: d['_count']?.sub_cat_product,
                                'prefix1': d?.parent?.prefix,
                                'prefix2': d?.parent?.sku_no,
                                'prefix3': d?.prefix,
                                'prefix4': d?.sku_no
                              }
                            });
                            const formattedData = updatedData.map((item) => ({
                              "Category": item.category,
                              "Prefix 1": item.prefix1,
                              "Prefix 2": item.prefix2,
                              "Sub Category": item.subCategory,
                              "Prefix 3": item.prefix3,
                              "Prefix 4": item.prefix4,
                              "# Of Products": item.product_count,
                            }));

                            const worksheet = XLSX.utils.json_to_sheet(formattedData);

                            // Create workbook and add worksheet
                            const workbook = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

                            // Generate buffer
                            const excelBuffer = XLSX.write(workbook, {
                              bookType: "xlsx",
                              type: "array"
                            });

                            // Save file
                            const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
                            saveAs(fileData, "Sub Category List.xlsx");
                          }}
                        >
                          <CloudDownloadOutlinedIcon color="primary" />
                        </IconButton>
                      </Tooltip>)
                      : ''}
                    <TextField
                      size="small"
                      id="outlined-search"
                      type="text"
                      placeholder={Number(selectedPage) === 0 ? "Search Category" : "Search Subcategory"}
                      sx={{
                        background: '#ebeaea'
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon fontSize="small" />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          searchingText && ( // Show the clear icon only if there's text in the field
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => {
                                  setSearchText('');
                                  onGridReady({
                                    api: gridApi,
                                    searchingText: ''
                                  });
                                }}
                              >
                                <ClearIcon fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          )
                        ),
                      }}
                      value={searchingText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          onGridReady({
                            api: gridApi,
                            searchingText: e.target.value
                          });
                        }
                      }}
                    />
                    {['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && (
                      <Button
                        size="Medium"
                        variant="contained"
                        startIcon={<AddIcon />}
                        style={{
                          height: 39
                        }}
                        onClick={() => setDialogOpen(true)}
                      >
                        Create
                      </Button>
                    )}
                  </>
                ) : (
                  <>
                    {isUser?.code === 'mvedasMasterAdmin' || isUser?.code === 'mvedasAdmin' ? (
                      <Tooltip title="Download Product List">
                        <IconButton
                          onClick={async () => {
                            const formattedData = returnedData.map((item) => ({
                              "Image": item?.images?.[0]?.sortUrl ? `${process.env.REACT_APP_IMAGEURL}bbn=${item?.images?.[0]?.sortUrl}&uid=${user?.user_id}` : 'https://dummyimage.com/100x100/000/fff',
                              "Category": item?.category?.name,
                              "Subcategory": item?.["sub_category"]?.name,
                              "Description": `${item?.category?.name ? item?.category?.name : ''}, ${item?.["sub_category"]?.name ? item?.["sub_category"]?.name : ''}`,
                              "Manufacturer": item?.manufacturer?.name ? item?.manufacturer?.name : '',
                              "Vendor": item?.vendor?.name ? item?.vendor?.name : '',
                              "Model": item?.model ? item?.model : '--',
                              "Catalog #": item?.catalog ? item?.catalog : '',
                              "Numeric ID": item?.is_customer_product ? `C-${item?.alternate_id}` : item?.category?.["sku_no"] ? `${item?.category?.["sku_no"]}${item?.sub_category?.["sku_no"]}-${String(item?.["numaric_sku"]).padStart(3, '0')}` : '--',
                              "Alphanumeric ID": item?.is_customer_product ? `C-${item?.alternate_id}` : item?.category?.prefix ? `${item?.category?.prefix}${item?.sub_category?.prefix}-${String(item?.["numaric_sku"]).padStart(3, '0')}` : '--',
                              "Custom ID 1": item?.custom_id_1 !== null ? item?.custom_id_1 : '--',
                              "Custom ID 2": item?.custom_id_2 !== null ? item?.custom_id_2 : '--',
                              "Govt. ID": item?.govt_id !== null ? item?.govt_id : '--',
                              "List Price": `₹ ${item?.list_price !== null ? Intl.NumberFormat('en-IN').format(item?.list_price) : 0}`,
                              "Long Description": item?.description ? item?.description : '',
                              "Notes": item?.notes ? item?.notes : '',
                              "Discontinued": Discontinues.find((a) => a.value === item?.discontinued)?.name || '--',
                              "Type": ProductType.find((a) => a.value === item?.type)?.name || '--',
                              "Furnish Responsibility": Responsibility.find((a) => a.value === item?.furnish_responsibility)?.name || '--',
                              "Install Responsibility": Responsibility.find((a) => a.value === item?.install_responsibility)?.name || '--',
                              "Life Expectancy / Lifespan": item["life_expectancy"],
                              "Lead Time": item["lead_time"],
                              "Architectural Code": ArchitecturalCode.find((a) => a.value === item?.architectural_code)?.name || '--',
                              "Alternate ID": item["alternate_id"] ? `C-${item["alternate_id"]}` : '--',
                              "Inventory ID": item["inventory_id"],
                              "Architecturally Significant": item?.architecturally_significant !== null ? (item?.architecturally_significant ? 'Yes' : 'No') : '--',
                              "Spatially Significant": item?.spatially_significant !== null ? (item?.spatially_significant ? 'Yes' : 'No') : '--',
                              "Units": Units.find((a) => a.value === item?.units)?.name,
                              "Width": getSize(item?.units, item?.width),
                              "Height": getSize(item?.units, item?.height),
                              "Depth": getSize(item?.units, item?.depth),
                              "Clearance - Left": getSize(item?.units, item?.clearance?.left),
                              "Clearance - Right": getSize(item?.units, item?.clearance?.right),
                              "Clearance - Back": getSize(item?.units, item?.clearance?.back),
                              "Clearance - Front": getSize(item?.units, item?.clearance?.front),
                              "Clearance - Top": getSize(item?.units, item?.clearance?.top),
                              "Clearance - Bottom": getSize(item?.units, item?.clearance?.bottom),
                              "Mouting": Mounting.find((a) => a.value === item?.mounting)?.name,
                              "Max Weight": getWeight(item?.units, item?.max_weight),
                              "Ship Weight": getWeight(item?.units, item?.ship_weight),
                              "Operating Weight": getWeight(item?.units, item?.operating_weight),
                              "DA Complient": item?.da_complient !== null ? (item?.da_complient ? 'Yes' : 'No') : '--',
                              "Antimicrobial": item?.antimicrobial !== null ? (item?.antimicrobial ? 'Yes' : 'No') : '--',
                              "Green": item?.green !== null ? (item?.green ? 'Yes' : 'No') : '--',
                              "Shielding": Shielding?.find((a) => a.value === item?.Shielding)?.name || '--',
                              "Seismic": item?.seismic !== null ? (item?.seismic ? 'Yes' : 'No') : '--',
                              "Spatial Remarks": item?.spatial_remarks ? item?.spatial_remarks : '',
                              "Voltage Type": VoltageType.find((a) => a.value === item?.electrical_data?.voltageType)?.name || '--',
                              "Volts": item?.electrical_data?.volts ? `${item?.electrical_data?.volts} V` : '--',
                              "Amps": item?.electrical_data?.amps ? `${item?.electrical_data?.amps} A` : '--',
                              "Watts": item?.electrical_data?.watts ? `${item?.electrical_data?.watts} W` : '--',
                              "kVA": item?.electrical_data?.kva ? `${item?.electrical_data?.kva} kVA` : '--',
                              "Hertz": item?.electrical_data?.hertz ? `${item?.electrical_data?.hertz} Hz` : '--',
                              "Electric Phase": ElectricalPhase.find((a) => a.value === item?.electrical_data?.electricalPhase)?.name || '--',
                              "Plug Type": PlugType.find((a) => a.value === item?.electrical_data?.plugtype)?.name || '--',
                              "Plug Details": item?.electrical_data?.plugdetail || '--',
                              "Emergency Power": item?.electrical_data?.emergencyPower ? 'Yes' : 'No',
                              "Remote Transformer": item?.electrical_data?.remoteTrans ? 'Yes' : 'No',
                              "Remote Switch / Controller": item?.electrical_data?.remoteSwitch ? 'Yes' : 'No',
                              "Electrical Remarks": item?.electrical_data?.electricalRemarks ? item?.electrical_data?.electricalRemarks : '',
                              "Tech Connection": item?.tech_connection_data?.isConnection ? 'Yes' : 'No',
                              "Connection Type": ConnectionType.find((a) => a.value === item?.tech_connection_data?.connectionType)?.name || '--',
                              "Network": Network.find((a) => a.value === item?.tech_connection_data?.network)?.name || '--',
                              "Technical Remarks": item?.tech_connection_data?.techRemarks ? item?.tech_connection_data?.techRemarks : '',
                              "Water Cold": item?.plumbing_data?.coldWater ? 'Yes' : 'No',
                              "Water Hot": item?.plumbing_data?.hotWater ? 'Yes' : 'No',
                              "Water Treated": item?.plumbing_data?.treatedWater ? 'Yes' : 'No',
                              "Steam": item?.plumbing_data?.steam ? 'Yes' : 'No',
                              "Medical Vaccum": item?.plumbing_data?.vaccumMedical ? 'Yes' : 'No',
                              "Dental Vaccum": item?.plumbing_data?.vaccumDental ? 'Yes' : 'No',
                              "Medical Gas": item?.plumbing_data?.medicalgas ? 'Yes' : 'No',
                              "Drain": item?.plumbing_data?.drain ? 'Yes' : 'No',
                              "Drain Location": DrainLocation.find((a) => a.value === item?.plumbing_data?.drainLocation)?.name || '--',
                              "Gas Type": GasType.find((a) => a.value === item?.plumbing_data?.gasType)?.name || '--',
                              "Gas Location": GasLocation.find((a) => a.value === item?.plumbing_data?.gasLocation)?.name || '--',
                              "Plumbing Remarks": item?.plumbing_data?.plumbingRemarks ? item?.plumbing_data?.plumbingRemarks : '',
                              "Vent": item?.mechanical_data?.vent ? 'Yes' : 'No',
                              "Vent Type": item?.mechanical_data?.vent ? (VentType.find((a) => a.value === item?.mechanical_data?.ventType)?.name || '--') : '--',
                              "Heat Dissipation (BTU/hr)": item?.mechanical_data?.heatDissipation || '--',
                              "Dissipation Type": DissipationType.find((a) => a.value === item?.mechanical_data?.dissipationType)?.name || '--',
                              "Mechanical Remarks": item?.mechanical_data?.mechanicalRemarks ? item?.mechanical_data?.mechanicalRemarks : '',
                              "Product Specification": `${process.env.REACT_APP_IMAGEURL}bbn=${item?.["specifications_doc"]?.[0]?.sortUrl}&uid=${user?.user_id}`,
                              "Product Brochure": `${process.env.REACT_APP_IMAGEURL}bbn=${item?.["brochure_doc"]?.[0]?.sortUrl}}&uid=${user?.user_id}`,
                              "Product Site-Planning": `${process.env.REACT_APP_IMAGEURL}${item?.["site_planning_doc"]?.[0]?.sortUrl}`,
                              "Product Operating Manual": `${process.env.REACT_APP_IMAGEURL}bbn=${item?.["operating_manual_doc"]?.[0]?.sortUrl}}&uid=${user?.user_id}`,
                              "URL": item?.["website_url"],
                              "2D": `${process.env.REACT_APP_IMAGEURL}bbn=${item?.["twod_doc"]?.[0]?.sortUrl}}&uid=${user?.user_id}`,
                              "3D": `${process.env.REACT_APP_IMAGEURL}bbn=${item?.["threed_doc"]?.[0]?.sortUrl}}&uid=${user?.user_id}`,
                              "Other Document": `${process.env.REACT_APP_IMAGEURL}bbn=${item?.["documents"]?.[0]?.sortUrl}}&uid=${user?.user_id}`
                            }));
                            const worksheet = XLSX.utils.json_to_sheet(formattedData);

                            // Create workbook and add worksheet
                            const workbook = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

                            // Generate buffer
                            const excelBuffer = XLSX.write(workbook, {
                              bookType: "xlsx",
                              type: "array"
                            });

                            // Save file
                            const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
                            saveAs(fileData, "Product List.xlsx");
                          }}
                        >
                          <CloudDownloadOutlinedIcon color="primary" />
                        </IconButton>
                      </Tooltip>) : ''}
                    {editedRows.length > 0 && (
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={async () => {
                          setDataLoding(true);
                          try {
                            await Promise.all(
                              editedRows.map(row => {
                                row.is_customer_product = false;
                                return apiRequest("put", `/product/${row.product_id}`, row);
                              })
                            );

                            showNotification("All changes saved successfully!", "success");
                            setEditedRows([]); // Clear after saving
                          } catch (error) {
                            showNotification(error?.response?.data?.error || error.message, "error");
                          } finally {
                            setDataLoding(false);
                          }
                        }}
                      >
                        Save
                      </Button>
                    )}
                    <TextField
                      size="small"
                      id="outlined-search"
                      type="text"
                      placeholder="Search Products"
                      style={{
                        background: '#ebeaea',
                      }}
                      fullWidth={fromTemplate}
                      value={searchingText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          onGridReady({
                            api: gridApi,
                            searchingText: e.target.value
                          });
                        }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon fontSize="small" />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          searchingText && ( // Show the clear icon only if there's text in the field
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => {
                                  setSearchText('');
                                  onGridReady({
                                    api: gridApi,
                                    searchingText: ''
                                  });
                                }}
                              >
                                <ClearIcon fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          )
                        ),
                      }}
                    />
                    {(!fromTemplate || currentPlanId !== 7) && (
                      <Button
                        size="Medium"
                        variant="contained"
                        startIcon={<AddIcon />}
                        style={{
                          height: 39,
                        }}
                        onClick={() => navigate('/app/catalog/create-product')}
                      >
                        Create
                      </Button>
                    )}
                  </>
                )}
              </DemoBox>
            )}
          </>
        )
        }
      </DemoBox1 >
      {activeTab !== 2 && (
        <DataTable
          height={fromTemplate ? "59vh" : "74vh"}
          columnDefs={updatedColumns}
          rowsPerPage={rowsPerPage}
          onGridReady={onGridReady}
          toolPanel={toolPanel}
          onPaginationChanged={onPaginationChanged}
          singleClickEdit={false}
          modelType="infinite"
          selectionType={fromTemplate ? "single" : selectedPage === 2 ? "single" : "multiple"}
          onCellValueChanged={async (event) => {
            const { data } = event;

            setEditedRows((prev) => {
              const exists = prev.find(row => row.product_id === data.product_id);
              if (exists) {
                // Update the existing one
                return prev.map(row => row.product_id === data.product_id ? data : row);
              } else {
                // Add new edited row
                return [...prev, data];
              }
            });
          }}
          onSelectionChanged={() => {
            if (Number(selectedPage) !== 0) {
              if (gridApi) {
                const selectedNodes = gridApi.getSelectedNodes();
                if (selectedNodes?.length < returnedData?.length * activePage) {
                  setIsChecked(false);
                  if (selectedNodes?.length === 0) {
                    setIndeterminate(false);
                  } else {
                    setIndeterminate(true);
                  }
                } else {
                  setIsChecked(true);
                  setIndeterminate(false);
                }
                if (Number(selectedPage) === 1) {
                  selectedNodes.map((node) => node.data.category_id);
                  setSelectedData(selectedNodes.map((node) => node.data.category_id));
                  setSubCategoryId(selectedNodes.map((node) => node.data.category_id));
                } else if (Number(selectedPage) === 2) {
                  if (setSelectedProduct) {
                    setSelectedProduct(selectedNodes.map((node) => node.data));
                  }
                  setSelectedData(selectedNodes.map((node) => node.data));
                }
              }
            }
          }}
          onColumnMoved={() => {
            if (activeTab === 1 || activeTab === 3) {
              setProductColumn(gridApi.getAllGridColumns().map((column) => column.getColDef()));
            }
          }}
        />
      )}
      {activeTab === 2 && (
        <Supplier />
      )}
    </Box >
  )
}